export { default } from './TOS'
